import { render, staticRenderFns } from "./ModuleTwo.vue?vue&type=template&id=0bf7939e&scoped=true"
import script from "./ModuleTwo.vue?vue&type=script&lang=js"
export * from "./ModuleTwo.vue?vue&type=script&lang=js"
import style0 from "./ModuleTwo.vue?vue&type=style&index=0&id=0bf7939e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7939e",
  null
  
)

export default component.exports